import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'

export default function Alert() {
    return (
        <div className="rounded-md bg-yellow-50 p-4">
            <div className="flex">
                <div className="flex-shrink-0">
                    <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-yellow-800">Invalid Radius</h3>
                    <div className="mt-2 text-sm text-yellow-700">
                        <p>
                            Please enter a value less than or equal to 2 km. We'll be adding functionality to support distances greater than 2 km soon.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}